import type { FunctionComponent } from 'react';

import { FilterIcon } from '@/domains/core/tamagoshiTailwind/icons/FilterIcon';

import { QuickFilterButton } from '../QuickFilterButton/QuickFilterButton';
import { text } from './translations';

interface Props {
  onClick?: () => void;
}

export const QuickOpenFilterPanel: FunctionComponent<Props> = ({ onClick }) => (
  <QuickFilterButton icon={FilterIcon} onClick={onClick} text={text} />
);

QuickOpenFilterPanel.displayName = 'QuickOpenFilterPanel';
